import { Directive, inject } from '@angular/core';
import { Dialog, DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Directive()
export class BaseDialogDirective<T = unknown, Y = any> {
  protected dialogData: Y = inject<Y>(DIALOG_DATA);
  protected dialogRef: DialogRef = inject(DialogRef);
  protected dialog: Dialog = inject(Dialog);

  protected closeDialog(result?: T): void {
    this.dialogRef.close(result);
  }
}
